<template>
  <v-navigation-drawer dark absolute expand-on-hover permanent right>
    <v-list dense>
      <v-list-item @click="loadSummary()">
        <v-list-item-icon>
          <v-icon>mdi-poll</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Most featured</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item @click="loadSummary()">
        <v-list-item-icon>
          <v-icon>mdi-chart-arc</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>By choice</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item @click="loadTable()">
        <v-list-item-icon>
          <v-icon>mdi-chart-arc</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Table</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Individuals</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <template v-for="doc in filteredUsers">
        <v-list-item :key="doc.id" @click="loadUser(doc.uid)">
          <v-list-item-icon>
            {{ doc.initial }}
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title
              >{{ doc.first }} {{ doc.last }}</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "ResultsFunctionalityBar",
  props: {
    doc: {
      type: Object,
    },
  },
  computed: {
    filteredUsers() {
      // return this.doc ? this.doc.users.filter(item => item.webrole == 'user') : null
      return this.doc.users;
    },
  },
  methods: {
    loadUser(val) {
      this.$emit("loadUser", val);
    },
    loadTable(val) {
      this.$emit("loadTable", val);
    },
    loadSummary(val) {
      this.$emit("loadSummary", val);
    },
  },
};
</script>
